import { spacing } from '@constants/spacing';
import { baseUrl, knowledgeBase, legacyPrivacy, legacyTerms, privacyPolicy, raiseTicket } from '@constants/URLs';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useUserHasRole } from '@hooks/useUserHasRole';
import { Box, Divider, styled } from '@mui/material';
import { Button } from '@partful/shared/ui/Button';
import { useTenant } from '@providers/Tenant';
import { useTranslation } from 'react-i18next';
import { allowedRoles, currentYear, StyledA } from './shared';

const ButtonContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: ${spacing.xSmallSpacing};
  min-width: max-content;
`;

const StyledBox = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;
  whitespace: nowrap;
`;

export default function GenericFooter() {
  const { t } = useTranslation();
  const { enabledFeatures } = useTenant();
  const configManagement = enabledFeatures.includes('configuration-management');
  const canSeeButtons = useUserHasRole(allowedRoles) && configManagement;

  return (
    <>
      <ButtonContainer>
        {canSeeButtons && (
          <>
            <Button variant="secondary" href={knowledgeBase} target="_blank" size="small">
              {t('navigation:knowledgeBase')}
              <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
            </Button>
            <Button size="small" variant="secondary" href={raiseTicket} target="_blank">
              {t('navigation:reportAnIssue')}
              <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
            </Button>
          </>
        )}
      </ButtonContainer>
      <StyledBox>
        <StyledA href={configManagement ? privacyPolicy : legacyPrivacy}>{t('navigation:privacyPolicy')}</StyledA>
        <Divider orientation="vertical" flexItem />
        <StyledA href={legacyTerms}>{t('navigation:termsOfUse')}</StyledA>
        <Divider orientation="vertical" flexItem />
        {t('navigation:poweredBy')}&nbsp;
        <StyledA href={baseUrl} target="_blank" rel="noopener noreferrer">
          Partful
        </StyledA>
        &nbsp;
        {currentYear}
      </StyledBox>
    </>
  );
}
